//libraries
import _ from 'lodash';

/**
 * Import all constants as an object.
 */
import * as actionType from "../../constants/actionType";


let initialState = {
  payments: []
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export default function (state, action) {
    state = state || initialState;
    switch (action.type) {
        case actionType.SALES_SUMMARY_CURRENT_PAYMENT:
            return _.assign({}, state, {
            payments: action.payload.payments
            });
        case actionType.SALES_SUMMARY_CURRENT_PAYMENT_RESET:
            return initialState;
        default:
            return state;
    }
}